import './header.scss';

import React from 'react';
import { Translate } from 'react-jhipster';
import LoadingBar from 'react-redux-loading-bar';

import NiasNavbar from 'app/shared/layout/nias/nias-navbar';
import { fetchActiveGlobalNotificationQuery } from "app/shared/global-notification/global-notification.queries";

export interface IHeaderProps {
  isAuthenticated: boolean;
  ribbonEnv: string;
  isInProduction: boolean;
  isOpenAPIEnabled: boolean;
  currentLocale: string;
  hasAnonymousRole: boolean;
}

const Header = (props: IHeaderProps) => {

  const renderDevRibbon = () =>
    props.isInProduction === false ? (
      <div className="ribbon dev">
        <a href="">
          <Translate contentKey={`global.ribbon.${props.ribbonEnv}`} />
        </a>
      </div>
    ) : null;

  const { data: globalNotification } = fetchActiveGlobalNotificationQuery({ enabled: props.isAuthenticated });

  return (
    <div id="app-header" className="header">
      {renderDevRibbon()}
      <LoadingBar className="loading-bar" />
      <NiasNavbar isAuthenticated={props.isAuthenticated} hasAnonymousRole={props.hasAnonymousRole}></NiasNavbar>
      <div className="global-notification">{globalNotification}</div>
    </div>
  );
};

export default Header;
